import { render } from "./TeikiTop.vue?vue&type=template&id=3182f4bb&scoped=true"
import script from "./TeikiTop.vue?vue&type=script&lang=js"
export * from "./TeikiTop.vue?vue&type=script&lang=js"

import "./TeikiTop.vue?vue&type=style&index=0&id=3182f4bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3182f4bb"]])

export default __exports__